import imgProj_GymPersonalTrainer_Website from '../assets/projectImg/imgProj_GymPersonalTrainer_Website.png';
import imgProj_Spanzuratoarea_Game from '../assets/projectImg/imgProj_Spanzuratoarea_Game.png';
import imgProj_LastWord_ChatApp from '../assets/projectImg/imgProj_LastWord_ChatApp.png';
import imgProj_Mern_Website from '../assets/projectImg/imgProj_Mern_Website.png';
import imgProj_NodeJsOnlineStore_Website from '../assets/projectImg/imgProj_NodeJsOnlineStore_Website.png';
import imgProj_PetAdopt_Website from '../assets/projectImg/imgProj_PetAdopt_Website.png';
import imgProj_Encrypt_EncryptionApp from '../assets/projectImg/imgProj_Encrypt_EncryptionApp.png';
import imgProj_MarioNet_Game from '../assets/projectImg/imgProj_MarioNet_Game.png';
import imgProj_BlackJack_Game from '../assets/projectImg/imgProj_BlackJack_Game.png';
import imgProj_CatsVsDogs_Game from '../assets/projectImg/imgProj_CatsVsDogs_Game.png';
import imgProj_DresoriDeCaini_Placeholder from '../assets/projectImg/imgProj_DresoriDeCaini_Placeholder.png';
import imgProj_PackSenseAcademy_Website from '../assets/projectImg/imgProj_PackSenseAcademy_Website.png';
import imgProj_INKoMOD_Game from '../assets/projectImg/imgProj_INKoMOD_Game.png';

export const projectData = [
	{
		id: 13,
		title: 'INKoMOD.eu',
		description:
			'Joc RPG turn-based complex, bazat pe text, construit pe o arhitectură Client-Server. Dezvoltat utilizând stiva MERN, aplicația integrează motoare logice customizate și generare procedurală. Sistemul include management avansat al stării globale pentru atribute biologice, logistică și inventar.',
		imageSrc: imgProj_INKoMOD_Game,
		websiteLink: 'https://www.inkomod.eu',
		githubLinkFE: 'https://github.com/OneaMarius/Inkomod-Client',
		githubLinkBE: 'https://github.com/OneaMarius/Inkomod-Server',
		tags: ['React', 'Node.js', 'MongoDB', 'Game Dev', 'State Management', 'Full-Stack'],
	},
	{
		id: 12,
		title: 'DresoriDeCaini.ro',
		description:
			'Pagina de pre-lansare cu funcționalitate completă de colectare lead-uri. Dezvoltată cu React/Vite (FE) și Node.js/Express/MongoDB (BE), rulând pe Netlify și Heroku. Include segmentare Dresor/Client și pagini legale.',
		imageSrc: imgProj_DresoriDeCaini_Placeholder,
		websiteLink: 'https://www.dresoridecaini.ro',
		githubLinkFE: 'https://github.com/OneaMarius/fe-dresoridecaine-phv2',
		githubLinkBE: 'https://github.com/OneaMarius/be-dresoridecaine-phv2',
		tags: ['React', 'Node.js', 'MongoDB', 'Full-Stack', 'Heroku', 'API'],
	},
	{
		id: 11,
		title: 'Pack Sense Academy',
		description:
			'Un website informativ complex dezvoltat cu  React, destinat unei școli de dresaj canin. Include galerii, formulare de contact, secțiuni detaliate de servicii și un blog. Are parete administrative pentru gestionarea conținutului și este optimizat SEO.',
		imageSrc: imgProj_PackSenseAcademy_Website,
		websiteLink: 'https://omd-packsenseacademy.netlify.app',
		githubLinkFE: 'https://github.com/OneaMarius/FE-packsenseacademy',
		githubLinkBE: 'https://github.com/OneaMarius/BE-packsenseacademy',
		tags: ['MERN', 'Full-Stack', 'UX/UI', 'Vite', 'Shop', 'Mail', 'API', 'Admin'],
	},
	{
		id: 10,
		title: 'Gym Personal Trainer',
		description:
			'Un site web pentru antrenor personal, dezvoltat cu React JS, HTML si CSS. Include un formular de contact, o galerie de imagini, si un video de prezentare.',
		imageSrc: imgProj_GymPersonalTrainer_Website,
		websiteLink: 'https://catalinmicu.netlify.app',
		githubLinkFE: 'https://github.com/OneaMarius/pt-catalinmicu',
		tags: ['React', 'Front-End', 'CSS'],
	},
	{
		id: 9,
		title: 'Spanzuratoarea',
		description:
			'Spânzurătoarea este un joc web interactiv construit cu React, Node.js și MongoDB, ce oferă o experiență clasică modernizată. Include peste 1500 de cuvinte în limba română, statistici de joc și interfață responsive. Backend-ul gestionează logica și datele, iar frontend-ul oferă o interfață intuitivă.',
		imageSrc: imgProj_Spanzuratoarea_Game,
		websiteLink: 'https://omd-spanzuratoarea-2.netlify.app/',
		githubLinkFE: 'https://github.com/OneaMarius/FE-Spanzuratoarea2',
		githubLinkBE: 'https://github.com/OneaMarius/BE-Spanzuratoarea2',
		tags: ['MERN', 'Full-Stack', 'Game'],
	},
	{
		id: 8,
		title: 'Last Word',
		description:
			'Last Word este o aplicație de chat unică, bazată pe un sistem de comunicare rând pe rând. Utilizatorii pot trimite un mesaj doar după ce au primit un răspuns, promovând astfel conversații mai deliberate. Aplicația reține doar ultimul mesaj, eliminând istoricul și permițând utilizatorilor să se conecteze și să se găsească reciproc pe baza numelui de utilizator.',
		imageSrc: imgProj_LastWord_ChatApp,
		websiteLink: 'https://omdlastword.netlify.app/',
		githubLinkFE: 'https://github.com/OneaMarius/FE-OMDchatApp',
		githubLinkBE: 'https://github.com/OneaMarius/BE-OMDchatApp',
		tags: ['MERN', 'Full-Stack', 'Chat'],
	},
	{
		id: 7,
		title: 'MERN Website',
		description:
			'MERN Website este o aplicație demo complexă, dezvoltată cu metodologia MERN (MongoDB, Express, React, Node.js). Proiectul demonstrează capacitatea de a crea aplicații full-stack, permițând utilizatorilor să adauge și să vizualizeze locații. Funcționalitatea principală include afișarea interactivă a acestor locații pe o hartă.',
		imageSrc: imgProj_Mern_Website,
		websiteLink: 'https://omd-mern-site.netlify.app/',
		githubLinkFE: 'https://github.com/OneaMarius/FE-Mern-Site',
		githubLinkBE: 'https://github.com/OneaMarius/BE-Mern-Site',
		tags: ['MERN', 'Full-Stack', 'Demo'],
	},
	{
		id: 6,
		title: 'NodeJs Onlie Store',
		description:
			'NodeJs Online Store este o aplicație de tip e-commerce, construită integral cu Node.js. Acest proiect servește ca o demonstrație a competențelor mele în dezvoltarea de aplicații full-stack, având un frontend generat dinamic de către server. Funcționalitatea sa principală permite utilizatorilor să adauge și să cumpere produse prin intermediul unei interfețe de magazin online.',
		imageSrc: imgProj_NodeJsOnlineStore_Website,
		websiteLink: 'https://omd-nodejs-onlineshop-564602d8e6be.herokuapp.com//',
		githubLinkBE: 'https://github.com/OneaMarius/BEFE-NodeJS-OnlineShop',
		tags: ['E-commerce', 'Full-Stack', 'Demo'],
	},
	{
		id: 5,
		title: 'Pet Adopt',
		description:
			'Pet Adopt este un website demonstrativ, conceput ca o platformă de adopție a animalelor. Utilizatorii pot lista animale pentru adopție, pot adopta animalele listate de alții sau le pot urmări. Aplicația permite, de asemenea, adăugarea de noi animale și include o funcționalitate de chat intern, facilitând comunicarea dintre utilizatori.',
		imageSrc: imgProj_PetAdopt_Website,
		websiteLink: 'https://omd-petadopt.netlify.app/',
		githubLinkFE: 'https://github.com/OneaMarius/FE-PetAdopt',
		githubLinkBE: 'https://github.com/OneaMarius/BE-PetAdopt',
		tags: ['MERN', 'Full-Stack', 'Chat', 'Demo'],
	},
	{
		id: 4,
		title: 'Encrypt',
		description:
			'Encrypt este o aplicație web de criptare a mesajelor, concepută pentru a fi simplu de utilizat. Permite utilizatorilor să cripteze și să decripteze mesaje folosind o cheie unică. Fiind o aplicație de tip frontend pur (fără backend), mesajele nu sunt stocate, asigurând astfel confidențialitatea completă a comunicării.',
		imageSrc: imgProj_Encrypt_EncryptionApp,
		websiteLink: 'https://omd-encrypt-app.netlify.app/',
		githubLinkFE: 'https://github.com/OneaMarius/FE-Encrypt-App',
		tags: ['JavaScript', 'Front-End', 'Criptare'],
	},
	{
		id: 3,
		title: 'MarioNet',
		description:
			'MarioNet este o aplicație interactivă și amuzantă, ce oferă utilizatorilor control total asupra unei marionete virtuale. Aceștia pot manipula fiecare parte a corpului pentru a crea poziții unice. Ulterior, pot ajusta viteza unei melodii și a mișcărilor de dans ale marionetei, transformând-o într-un dansator imprevizibil, dar sincronizat cu ritmul.',
		imageSrc: imgProj_MarioNet_Game,
		websiteLink: 'https://omd-dancing-marionet.netlify.app/',
		githubLinkFE: 'https://github.com/OneaMarius/FE-Dancing-MarioNet',
		tags: ['JavaScript', 'Front-End', 'Game'],
	},
	{
		id: 2,
		title: 'BlackJack',
		description:
			'BlackJack este un mini-joc pe care l-am dezvoltat pentru a-mi testa și consolida abilitățile de bază în dezvoltarea de aplicații front-end. Construit cu JavaScript, HTML și CSS, acest proiect a reprezentat un exercițiu esențial în înțelegerea logicii de joc și a interacțiunii dinamice cu utilizatorul.',
		imageSrc: imgProj_BlackJack_Game,
		websiteLink: 'https://omd-blackjack-game.netlify.app/',
		githubLinkFE: 'https://github.com/OneaMarius/FE-Blackjack-Game',
		tags: ['HTML', 'CSS', 'JavaScript', 'Game'],
	},
	{
		id: 1,
		title: 'Cats Vs Dogs',
		description:
			'Cats Vs Dogs este primul meu mini-joc de tip "fight", conceput pentru doi jucători. Inspirat de jocurile arcade clasice, acesta include funcții de bază precum scor, viață și runde, oferind o experiență de joc simplă și competitivă, bazată pe un concept amuzant.',
		imageSrc: imgProj_CatsVsDogs_Game,
		websiteLink: 'https://omd-cats-vs-dogs.netlify.app/',
		githubLinkFE: 'https://github.com/OneaMarius/FE-Cats-Vs-Dogs',
		tags: ['HTML', 'CSS', 'JavaScript', 'Game'],
	},
];